export const errorMessages = {
  required: 'Field is required',
  serialNumberFormat: 'Serial number must be from 1 to 6 HEX digits',
  uploadFileLimitSize: 'File size exceeds 1MB limit',
  minFirmwareNameLength: 'Firmware name should be equal at least 4 characters',
  maxFormFieldLength: 'Form field exceeds the maximum allowed length of 50 characters',
  maxTagFormFieldLength: 'Form field exceeds the maximum allowed length of 255 characters',
  firmwareVersionFormat: 'Firmware version has an incorrect format',
};
